import { httpClient } from 'shared/lib'
import { AxiosError, isAxiosError } from 'axios'
import consoleMessage from 'shared/utils/helpers/consoleMessage'
import { ProducersResponse } from './types'

export function fetchProducers(searchPhrase: string) {
   let errMessage = ''

   return httpClient
      .post<ProducersResponse>(`producers/search`, {
         searchPhrase,
      })
      .then((res) => {
         if (res.data) {
            return res.data
         }
         throw new Error('No data in request')
      })
      .catch((error: Error | AxiosError<ErrorType>) => {
         if (isAxiosError<ErrorType>(error)) {
            errMessage =
               `status: ${error.response?.status},url: ${error.response?.config.url}, message:${error.response?.data?.errors[0].defaultMessage}` ||
               'Unexpected error'
         } else {
            errMessage = error.message
         }
         consoleMessage('Producers search fetchProducers service', errMessage, 'error')
         throw new Error(errMessage)
      })
}
